import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {Payday} from "../Payday";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {PaydayGameData} from "../server/PaydayData";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";

/**
 * Created by jonas on 2023-11-01.
 */

export class PaydayPromoPanelConfig implements PromoPanelGameConfiguration{
    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Payday",
            hasActionSpin: true,
            disabledFeatureBets: ["CRASH_GAME"],
            graphics: {
                backgroundTextureName: "resources/images/Intro_BG.jpg"
            },
            getParsedData: (response: PaydayGameData, bet: number, prevResponse: PaydayGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpins(response),
                    totalSpinWinnings: this.getTotalWin(response, prevResponse),
                    isBigWin: this.isBigWin(response, prevResponse),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response, prevResponse),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: this.isBonudEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getTotalWin(response: PaydayGameData, prevResponse:PaydayGameData):number {
        return response.thisResponseWinnings;
    }

    private isFreespinsMode(response:PaydayGameData):boolean {
        return response.mode == GameMode.FREESPIN;
    }

    private isFreeSpins(response:any){
        return response.mode == GameMode.NORMAL && response.nextMode == GameMode.FREESPIN;
    }

    private getWinSize(response:PaydayGameData) {
        return response.thisResponseWinnings;
    }

    private getFeatureName(response: PaydayGameData, prevResponse: PaydayGameData): string {
        if (response.mode == GameMode.FREESPIN || response.nextMode == GameMode.FREESPIN)
            if (response.clawPositions.length == 5)
                return "CLAWIEST SPINS";
            else if (response.clawPositions.length == 3)
                return "CLAWIER SPINS";
            else
                return "CLAW SPINS";
        else
            return "NORMAL";
    }

    private isBonudEnd(response: PaydayGameData):boolean {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            Payday.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            Payday.soundPlayer.playSound("asBigWin");
    }

    private isBigWin(response:PaydayGameData, prevResponse:PaydayGameData): boolean {
        let winRatio: number = Helper.ceilToDecimals((response.thisResponseWinnings / Payday.getBetPrice()), 2);

        return response.wasFeatureBuy ? winRatio >= 1 : winRatio >= 15;
    }

    private isRoundComplete(response: PaydayGameData): boolean {
        return  ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }


}